<template>
    <div class="filter-date" v-lg-click-outside="hideCalendar">
        <div class="input-group">
            <input
                :value="rangeFormat.start"
                class="border form-control rounded filter-date__input-date"
                readonly
            />
            <span class="p-2 input-group-addon input-group-text border">
                to
            </span>
            <input
                :value="rangeFormat.end"
                class="border rounded form-control filter-date__input-date"
                readonly
            />
            <CButton
                @click="collapse=!collapse"
                class="input-group-prepend filter-date__btn-calendar"
                title="Open searcher date"
            >
                <CIcon class="icon" :content="$options.icons.cilCalendar"/> 
            </CButton>
        </div>
        <CCollapse :show="collapse" class="filter-date__collapse shadow">
            <CContainer>
                <CRow
                    class="filter-date__body"
                >
                    <CCol md="8" sm="12" class="filter-date__calendar-container">
                        <!-- Filter leads -->
                        <DatePicker
                            :is-dark="darkMode"
                            class="filter-date__calendar"

                            v-model="range"
                            
                            :masks="masks"
                            is-range
                            is-expanded 
                            :timezone="timezone"
                        >
                        </DatePicker>
                    </CCol>
                    <CCol md="4" class="p-0 filter-date__list-ranges-container">
                        <h6 class="filter-date__list-ranges-title">{{ $t('predefined_dates') }}</h6>
                        <CListGroup class="filter-date__list-ranges">
                            <CListGroupItem 
                                :action="true"
                                class="list-ranges__item"
                                @click="setRangeDateByOption('today')"
                            >
                                {{ $t('today') }}
                            </CListGroupItem>
                            <CListGroupItem 
                                :action="true"
                                class="list-ranges__item"
                                @click="setRangeDateByOption('yesterday')"
                            >
                                {{ $t('yesterday') }}
                            </CListGroupItem>
                            <CListGroupItem 
                                :action="true"
                                class="list-ranges__item"
                                @click="setRangeDateByOption('last_7_days')"
                            >
                                {{ $t('last_7_days') }}
                            </CListGroupItem>
                            <CListGroupItem 
                                :action="true"
                                class="list-ranges__item"
                                @click="setRangeDateByOption('this_month')"
                            >
                                {{ $t('This month') }}
                            </CListGroupItem>
                            <CListGroupItem 
                                :action="true"
                                class="list-ranges__item"
                                @click="setRangeDateByOption('last_year')"
                            >
                                {{ $t('Last year') }}
                            </CListGroupItem>
                        </CListGroup>
                    </CCol>
                </CRow>
                <CRow
                    alignHorizontal='between'
                    class="filter-date__footer"
                    
                >
                        <CButton
                            class="filter-date_btn-cancel"
                            variant="ghost"
                            @click="collapse = false"
                        >
                            {{ $t('cancel') }}
                        </CButton>
                        <CButton
                            class="filter-date__btn-filter"
                            title="Start search"
                            color="primary"
                            @click="clickButtonContinue()"
                        >
                            {{ $t('continue') }}
                        </CButton>
                </CRow>
            </CContainer>
        </CCollapse>
        
    </div>
    
    
</template>

<script>
import {cilFilter, cilCalendar } from '@coreui/icons';
import Calendar from 'v-calendar/lib/components/calendar.umd';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import { mapGetters } from "vuex";
import dateMixin from '~/mixins/date.js';

import clickOutside from '~/directives/ClickOutside.js';

export default {
    name: "FilterDateComponent",
    icons:{
        cilFilter,
        cilCalendar
    },

    mixins: [ dateMixin ],
    components:{
        Calendar,
        DatePicker
    },
    directives:{
        'lg-click-outside': clickOutside
    },
    data(){
        return {
            range: {
                start: new Date(),
                end: new Date(),
            },
            modelConfig: {
                start: {
                    timeAdjust: '00:00:00',
                },
                end: {
                    timeAdjust: '',
                },
            },
            masks: {
                input: 'YYYY-MM-DD h:mm',
            },
            timezone:'',
            collapse:false
        }
    },
    props:{
        value:{
            type: Object,
            default: () => {
                return {
                    from: null,
                    to: null,
                }
            }
        },
    },
    computed:{
        ...mapGetters({
            from:"filter/from",
            to:"filter/to",
            darkMode: "panel/darkMode",
        }),
        rangeFormat:function(){
            return {
                start:this.formatDate(this.range.start),
                end:this.formatDate(this.range.end)
            }
        }
    },
    watch: {
        range: {
            handler: function () {
                this.saveRangeStore(this.range);
                // this.emitEventUpdateData(this.range);
            },
            deep: true
        }
    },
    methods:{

        hideCalendar(){
            this.collapse = false;
        },
        emitEventUpdateData(data){
            this.$emit('updateData', data);
        },
        clickButtonContinue(){
            this.emitEventUpdateData({
                from:this.rangeFormat.start,
                to:this.rangeFormat.end
            });
            this.$emit('update:value', {
                from:this.rangeFormat.start,
                to:this.rangeFormat.end
            });
            this.collapse = false;
        },
        saveRangeStore: function(){
            this.$store.dispatch('filter/saveRangeDate', this.rangeFormat);
            
        },
        loadRange: function(){

            /* Init range start */

            let range = {
                start:this.getDate(),
                end:new Date()
            };
            if(this.from){
                range.start = new Date(this.from);
            }
            /* Init rang end */
            if(this.to){
                range.end = new Date(this.to);
            }
            if(this.value && this.value.from && this.value.to){
                range.start = new Date(this.value.from);
                range.end = new Date(this.value.to);
            }

            this.range = range;
        },

        setRangeDateByOption(option){
            switch (option) {
                case 'today':
                    this.range = {
                        start: this.getDate(),
                        end: this.getDate({
                            time: '23:59:59'
                        }),
                    }
                    break;
                case 'yesterday':
                    this.range = {
                        start: this.getDate({
                            prev_days: 1
                        }),
                        end: this.getDate({
                            prev_days: 1,
                            time: '23:59:59'
                        }),
                    }
                    break;
                case 'last_7_days':
                    this.range = {
                        start: this.getDate({
                            prev_days: 7
                        }),
                        end: this.getDate({
                            time: '23:59:59'
                        }),
                    }
                    break;
                case 'last_year':
                    this.range = {
                        start: this.getDate({
                            prev_days: 365
                        }),
                        end: this.getDate({
                            time: '23:59:59'
                        }),
                    }
                    break;
                case 'this_month':
                    this.range = this.getRangeDateThisMonth(); 
                    break;
                default:
                    break;
            }
        }


        
    },
    mounted(){
        // Init field from
        this.loadRange();
    
    }
    
}
</script>

<style lang="scss" scoped>
    /* input{
        height: auto !important;
    } */

    .w-4{
        width: 1rem;
    }
    .w-full{
        width: 100%;
    }
    .h-full{
        height: 100%;
    }
    .stroke-current{
        stroke: black;
    }
    .input-group-text{
        background-color: transparent;
        border: none;
        height: calc(1.5em + 0.75rem + 2px);
    }
    
    .filter-date{
        position: relative;

        & .filter-date__btn-calendar{
            display: flex;
            align-items: center;
        }
        & .filter-date__collapse{
            top:3rem;
            right: 0;
            padding: 1rem 1.2rem 0 1.2rem;
            margin-top: 1rem;
            position: absolute;
            z-index: 3600;
            // background-color: white;

            /* &:before{
                z-index: 1;
                content: "";
                position: absolute;
                width: 0;
                height: 0;
                margin-left: 0;
                top: -20px;
                right:0;
                box-sizing: border-box;
                
                border: 10px solid black;
                border-color: #fff transparent transparent transparent;
                
                transform-origin: 0 0;
                transform: rotate(45deg);
            } */

            // &:after{
            //     z-index: -1;
            //     content: "";
            //     position: absolute;
            //     width: 0;
            //     height: 0;
            //     margin-left: 0;
            //     top: -20px;
            //     right:0;
            //     box-sizing: border-box;
                
            //     border: 10px solid #fff;
            //     border-color: #fff transparent transparent transparent;
                
            //     transform-origin: 0 0;
            //     transform: rotate(130deg);
                
            //     box-shadow: 0 3px 3px 0 rgba(87, 59, 59, 0.1);
            // }
        }
        & .filter-date__calendar-container{
            border-right: 1px solid #eff2f5;
            padding: 0 1rem;
            & .filter-date__calendar{
                margin-bottom: 1rem;
                margin-right: 1rem;
            }
        }

        & .filter-date__list-ranges-container{
            & .filter-date__list-ranges-title{
                padding-left: 1rem;
                padding-top: 1rem;
                font-size: 0.9rem;

            }
        }
        & .filter-date__list-ranges{
            padding-left: 1rem;
            & .list-ranges__item{
                border: none;
                padding-left: 0;
                font-size: 0.9rem;

            }
        }

        & .filter-date__footer{
            border-top: 1px solid #eff2f5;
            padding: 1rem 0.5rem;
        }
    }

</style>